<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container>
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item :label="$t('label.contractCode')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['conCode']" :placeholder="$t('label.pleaseEnterTheContractCode')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['farmerCode']" :placeholder="$t('label.pleaseEnterTheCode')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('label.batchNo')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['breedBatchCode']" :placeholder="$t('label.pleaseSelectBatchNo')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="农户（手工填写）" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['peasant']" placeholder="请输入农户（手工填写）"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="farmCode" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['farmCode', validatorRules.farmCode]" placeholder="请输入farmCode"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="businessDate" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['businessDate', validatorRules.businessDate]" placeholder="请输入businessDate"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="amountPrice" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['amountPrice', validatorRules.amountPrice]" placeholder="请输入amountPrice"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="businessType" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['businessType', validatorRules.businessType]" placeholder="请输入businessType"></a-input>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">{{$t('button.submit')}}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'

  export default {
    name: 'EfsMarginLedgerForm',
    components: {
      JFormContainer,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          farmCode: {
            rules: [
              { required: true, message: '请输入farmCode!'},
            ]
          },
          businessDate: {
            rules: [
              { required: true, message: '请输入businessDate!'},
            ]
          },
          amountPrice: {
            rules: [
              { required: true, message: '请输入amountPrice!'},
            ]
          },
          businessType: {
            rules: [
              { required: true, message: '请输入businessType!'},
            ]
          },
        },
        url: {
          add: "/demo/marginLedger/efsMarginLedger/add",
          edit: "/demo/marginLedger/efsMarginLedger/edit",
          queryById: "/demo/marginLedger/efsMarginLedger/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'conCode','farmerCode','breedBatchCode','peasant','farmCode','businessDate','amountPrice','businessType'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'conCode','farmerCode','breedBatchCode','peasant','farmCode','businessDate','amountPrice','businessType'))
      },
    }
  }
</script>